import { render, staticRenderFns } from "./DialogCategoriasArmarios.vue?vue&type=template&id=b9a8614a&scoped=true"
import script from "./DialogCategoriasArmarios.vue?vue&type=script&lang=js"
export * from "./DialogCategoriasArmarios.vue?vue&type=script&lang=js"
import style0 from "./DialogCategoriasArmarios.vue?vue&type=style&index=0&id=b9a8614a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a8614a",
  null
  
)

export default component.exports